import React from "react";
import { StartBox } from "../components/";
import { Helmet } from "react-helmet-async";

const Start = () => {
	return (
		<>
			<Helmet>
				<title>أطلبها | كيف أبدأ</title>
				<meta
					name='description'
					content='ابدأ مع أطلبها بوابتك للتجارة الإلكترونية'
				/>
			</Helmet>
			<StartBox />
		</>
	);
};

export default Start;
